import { fragments as artOrderStatusFragments } from "../../application/apps/ArtApp/components/ArtOrderStatus/graph";
import { gql } from "@apollo/client";

const setOrderAutoApprovedMutation = gql`
  mutation($autoApproved: Boolean!, $orderId: ID!) {
    setOrderAutoApproved(autoApproved: $autoApproved, orderId: $orderId) {
      errors {
        orderId
        autoApproved
      }
      updatedOrder {
        id
        autoApproved
      }
      succeeded
    }
  }
  ${artOrderStatusFragments.order}
`;

export default setOrderAutoApprovedMutation;
